<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">招聘信息</span>
      <span class="zn-text-grey">点击招聘信息可查看详情</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div style="display:flex;margin:5px 10px">
        <el-autocomplete size="mini" v-model="keywords" :fetch-suggestions="listKeywords" @select="handleSelect" placeholder="关键词，输入职位或公司" style="width:100%">
          <template slot-scope="{ item }">
            <div>
              <span style="color:#aaa;margin-right:10px">{{ item.field }}</span>
              <span>{{ item.keyword }}</span>
              <span style="float:right">共有<span style="color:#409eff">{{ item.count }}</span>条结果，点击查看</span>
            </div>
          </template>
        </el-autocomplete>
        <el-button size="mini" type="primary" @click="searchData" style="margin-left:5px">搜索</el-button>
      </div>
      <div style="margin:5px 10px">
        <span>地域：</span>
        <el-select size="mini" v-model="city" multiple>
          <el-option v-for="(dy, k) in diYu" :key="k" :label="dy" :value="dy"></el-option>
        </el-select>
      </div>
      <div v-show="bulletinData.length == 0" style="color:#aaa;text-align:center">暂无数据</div>
      <el-card v-for="(item, k) in bulletinData" :key="k" class="company-zhaopin-item">
        <el-row>
          <el-col :span="16">
            <div class="a-link text-hidden" @click="showDetail(item)">
              {{ item.岗位名称 || item.标题 }}
              <span>{{ (item.新圆手细分职能 && item.新圆手细分职能.length > 0 && `（${item.新圆手细分职能.join('，')}）`) }}</span>
            </div>
          </el-col>
          <el-col :span="8" style="text-align:right">
            <span>{{ item.公司 || '--' }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="text-gray">
            <span>{{ (item.城市 && item.城市 instanceof Array && item.城市.join(' ')) || '--' }}</span>
            |
            <span>{{
              item.工作经验 && item.工作经验.length == 2 ? `${item.工作经验[0]}-${item.工作经验[1]}年` : '不限'
            }}</span>
            |
            <span>{{ item.学历要求 || '--' }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <span v-if="item.月薪范围 && item.月薪范围 instanceof String" class="bull-content">{{
              item.月薪范围
            }}</span>
            <span v-else-if="item.月薪范围 && item.月薪范围 instanceof Array" class="bull-content"
              >{{ item.月薪范围[0] }}-{{ item.月薪范围[1] }}</span
            >
            <span v-else>面议</span>
          </el-col>
          <el-col :span="8" style="text-align:right">
            <span class="text-gray">{{ item.pub_time || item.update_time || '--' }}</span>
          </el-col>
        </el-row>
      </el-card>
      <div v-show="this.bulletinData.length < 500 && this.pageSize * this.page <= this.bulletinData.length" class="company-info-more">
        <el-button primary type="text" @click="showMore">展开更多</el-button>
      </div>
    </div>
    <bulletinDetail ref="bulletinDetail"></bulletinDetail>
  </div>
</template>
<script>
import bulletinDetail from '../../../misc/src/bulletin/bulletinDetail'
import { diYu } from '../../../radish/src/constant/common-var'

export default {
  components: { bulletinDetail },
  props: {
    item: Object,
  },
  data() {
    return {
      loading: false,
      bulletinData: [],
      pageSize: 20,
      page: 1,
      keywords: '',
      city: [],
      diYu,
    }
  },
  methods: {
    goto(url) {
      window.open(url, '_blank')
    },
    showMore() {
      if (this.pageSize * this.page > this.bulletinData.length) return this.$message.info('没有更多了')
      this.page += 1
      this.loadBulletins()
    },
    initData() {
      this.bulletinData = []
      this.keywords = this.item.keyword || ''
      this.city = []
      this.pageSize = 20
      this.page = 1
      if (this.keywords) this.loadBulletins()
    },
    async listKeywords(queryString, cb) {
      if (this.loadingKeyword) return
      if (!queryString) {
        cb([]);
      } else {
        this.loadingKeyword = true
        const res = await app.service('wechat').externalApiGet({
          baseUrl: 'http://39.107.92.53:3000',
          path: '/api/official/listKeywords',
          method: 'GET',
          externalData: { keyword: queryString },
        })
        if (res.status === 'success') {
          console.log('listKeywords', res.data.data)
          cb(res.data.data);
        } else {
          this.$message.error(res.msg)
          cb([]);
        }
        this.loadingKeyword = false
      }
    },
    handleSelect(item) {
      this.bulletinData = []
      this.keywords = item.keyword
      this.page = 1
      this.loadBulletins()
    },
    searchData() {
      this.bulletinData = []
      this.page = 1
      this.loadBulletins()
    },
    async loadBulletins() {
      if (!this.keywords) return this.$message.info('请输入关键词')
      if (this.loading) return
      this.loading = true

      const param = {
        keywords: this.keywords,
        pageSize: this.pageSize,
        curPage: this.page,
      }
      if (this.city.length > 0) {
        param.search = { "城市": { "$in": this.city } }
      }
      const res = await app.service('wechat').externalApiGet({
        baseUrl: 'http://39.107.92.53:3000',
        path: '/api/official/customSearch',
        method: 'GET',
        externalData: param,
      })
      console.log('loadBulletins', res, res.data.jobs)
      if (res.status === 'success' && res.data.jobs) {
        const jobs = res.data.jobs
        this.bulletinData = this.bulletinData.concat(jobs)
      } else {
        this.$message.error(res.msg)
      }
      this.loading = false
    },
    showDetail(row) {
      this.$refs.bulletinDetail.show(row, 'bd', 'ofc')
    },
  },
}
</script>
<style src="../../../company/statistics/css/fullCompanyDetail.css" scoped></style>
<style src="../../../company/statistics/css/commonCompany.css" scoped></style>
<style>
.company-zhaopin-item {
  position: relative;
  margin: 10px;
}
</style>
<style scoped>
.company-job-button {
  background-color: #409eff;
  width: 60px;
  height: 24px;
  border: #409eff;
  color: #fff;
  font-size: 12px;
  border-radius: 2px;
  line-height: 18px;
  text-align: center;
}
.text-gray {
  color: grey;
}
.company-info-more {
  width: 20px;
  margin-left: 47%;
}
.text-hidden {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
